// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__zyYOB","tab":"ProcedureTabs_tab__1dz_8"};